import HTTP from '@/components/general/http/http'

import config from '@/config/env'

export default {
	getClients(data) {

		let url = config.api.baseUrl + '/api/clients' + data

		return HTTP
			.request()
			.get(url)
			.then(response => response)
			.catch(error => error)

	},
	createClient(data) {

		let url = config.api.baseUrl + '/api/clients'

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	},
	updateClient(data) {

		let url = config.api.baseUrl + '/api/clients'

		return HTTP
			.request()
			.put(url, data)
			.then(response => response)
			.catch(error => error)

	},
	deleteClient(data) {

		let url = config.api.baseUrl + '/api/clients' + data

		return HTTP
			.request()
			.delete(url)
			.then(response => response)
			.catch(error => error)

	},
	associateAccount(data) {

		let url = config.api.baseUrl + '/api/clients/associatedAccounts'

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	},
	deleteAssociationAccount(data) {

		let url = config.api.baseUrl + '/api/clients/associatedAccounts' + data

		return HTTP
			.request()
			.delete(url)
			.then(response => response)
			.catch(error => error)

	},
	validateCSVFile(data) {

		let url = config.api.baseUrl + '/api/clients/import/validation'

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	},
	importClients(data) {

		let url = config.api.baseUrl + '/api/clients/import'

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	},
	exportClients(data) {

		let url = config.api.baseUrl + '/api/clients/export'

		return HTTP
			.request()
			.post(url, data, {
				responseType: 'arraybuffer'
			})
			.then(response => response)
			.catch(error => error)

	},
	migrateCSVFile(router, data) {

		let url = config.api.baseUrl + router

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	}
}



// WEBPACK FOOTER //
// ./src/api/clients.js